var React = require('react');

function Ul (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("path",{"className":"cls-1","d":"M30.3,18.1v18.51c0,4.42-.24,7.83-6.2,7.83-4.72,0-6.18-2.47-6.18-7.83v-18.51","key":0}),React.createElement("polyline",{"className":"cls-1","points":"38.85 21.98 38.85 50.94 51.14 50.94","key":1}),React.createElement("circle",{"className":"cls-1","cx":"34.14","cy":"34.14","r":"33.24","key":2})])]);
}

Ul.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 68.27 68.27"};

module.exports = Ul;

Ul.default = Ul;
